import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';

class Navigator extends Component {
  componentWillReceiveProps(nextProps){
    if(nextProps.routeName){
      this.forceUpdate()
    }
  }
  render() {
    if (this.props.routeName) {
      return <Redirect to={this.props.routeName} push key={this.props.routeName}/>;
    }
    return null;
  }
}

Navigator.propTypes = {
  routeName: PropTypes.string,
};

Navigator.defaultProps = {
  routeName: null,
};

export default Navigator;



// WEBPACK FOOTER //
// ./src/app/navigator/navigator.js